/**
 * @hidden
 */
export var messages = Object.create({});



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/Localization/messages.js
// module id = 389
// module chunks = 93